/**
 * @fileoverview gRPC-Web generated client stub for catalog
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.17.3
// source: catalog.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as catalog_pb from './catalog_pb'; // proto import: "catalog.proto"


export class CatalogItemReqClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetCatalogItemList = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/GetCatalogItemList',
    grpcWeb.MethodType.UNARY,
    catalog_pb.CatalogItemListReq,
    catalog_pb.CatalogItemList,
    (request: catalog_pb.CatalogItemListReq) => {
      return request.serializeBinary();
    },
    catalog_pb.CatalogItemList.deserializeBinary
  );

  getCatalogItemList(
    request: catalog_pb.CatalogItemListReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.CatalogItemList>;

  getCatalogItemList(
    request: catalog_pb.CatalogItemListReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.CatalogItemList) => void): grpcWeb.ClientReadableStream<catalog_pb.CatalogItemList>;

  getCatalogItemList(
    request: catalog_pb.CatalogItemListReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.CatalogItemList) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/GetCatalogItemList',
        request,
        metadata || {},
        this.methodDescriptorGetCatalogItemList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/GetCatalogItemList',
    request,
    metadata || {},
    this.methodDescriptorGetCatalogItemList);
  }

  methodDescriptorGetItem = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/GetItem',
    grpcWeb.MethodType.UNARY,
    catalog_pb.ItembyIdReq,
    catalog_pb.CatalogItem,
    (request: catalog_pb.ItembyIdReq) => {
      return request.serializeBinary();
    },
    catalog_pb.CatalogItem.deserializeBinary
  );

  getItem(
    request: catalog_pb.ItembyIdReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.CatalogItem>;

  getItem(
    request: catalog_pb.ItembyIdReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.CatalogItem) => void): grpcWeb.ClientReadableStream<catalog_pb.CatalogItem>;

  getItem(
    request: catalog_pb.ItembyIdReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.CatalogItem) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/GetItem',
        request,
        metadata || {},
        this.methodDescriptorGetItem,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/GetItem',
    request,
    metadata || {},
    this.methodDescriptorGetItem);
  }

  methodDescriptorGetItemByCode = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/GetItemByCode',
    grpcWeb.MethodType.UNARY,
    catalog_pb.ItembyCodeReq,
    catalog_pb.CatalogItem,
    (request: catalog_pb.ItembyCodeReq) => {
      return request.serializeBinary();
    },
    catalog_pb.CatalogItem.deserializeBinary
  );

  getItemByCode(
    request: catalog_pb.ItembyCodeReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.CatalogItem>;

  getItemByCode(
    request: catalog_pb.ItembyCodeReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.CatalogItem) => void): grpcWeb.ClientReadableStream<catalog_pb.CatalogItem>;

  getItemByCode(
    request: catalog_pb.ItembyCodeReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.CatalogItem) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/GetItemByCode',
        request,
        metadata || {},
        this.methodDescriptorGetItemByCode,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/GetItemByCode',
    request,
    metadata || {},
    this.methodDescriptorGetItemByCode);
  }

  methodDescriptorGetPropertyList = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/GetPropertyList',
    grpcWeb.MethodType.UNARY,
    catalog_pb.propetylistReq,
    catalog_pb.propetylistRes,
    (request: catalog_pb.propetylistReq) => {
      return request.serializeBinary();
    },
    catalog_pb.propetylistRes.deserializeBinary
  );

  getPropertyList(
    request: catalog_pb.propetylistReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.propetylistRes>;

  getPropertyList(
    request: catalog_pb.propetylistReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.propetylistRes) => void): grpcWeb.ClientReadableStream<catalog_pb.propetylistRes>;

  getPropertyList(
    request: catalog_pb.propetylistReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.propetylistRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/GetPropertyList',
        request,
        metadata || {},
        this.methodDescriptorGetPropertyList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/GetPropertyList',
    request,
    metadata || {},
    this.methodDescriptorGetPropertyList);
  }

  methodDescriptorGetPropertyMinMax = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/GetPropertyMinMax',
    grpcWeb.MethodType.UNARY,
    catalog_pb.propetylistReq,
    catalog_pb.propertyminmaxRes,
    (request: catalog_pb.propetylistReq) => {
      return request.serializeBinary();
    },
    catalog_pb.propertyminmaxRes.deserializeBinary
  );

  getPropertyMinMax(
    request: catalog_pb.propetylistReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.propertyminmaxRes>;

  getPropertyMinMax(
    request: catalog_pb.propetylistReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.propertyminmaxRes) => void): grpcWeb.ClientReadableStream<catalog_pb.propertyminmaxRes>;

  getPropertyMinMax(
    request: catalog_pb.propetylistReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.propertyminmaxRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/GetPropertyMinMax',
        request,
        metadata || {},
        this.methodDescriptorGetPropertyMinMax,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/GetPropertyMinMax',
    request,
    metadata || {},
    this.methodDescriptorGetPropertyMinMax);
  }

  methodDescriptorGetGuid = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/GetGuid',
    grpcWeb.MethodType.UNARY,
    catalog_pb.guidReq,
    catalog_pb.guidRes,
    (request: catalog_pb.guidReq) => {
      return request.serializeBinary();
    },
    catalog_pb.guidRes.deserializeBinary
  );

  getGuid(
    request: catalog_pb.guidReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.guidRes>;

  getGuid(
    request: catalog_pb.guidReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.guidRes) => void): grpcWeb.ClientReadableStream<catalog_pb.guidRes>;

  getGuid(
    request: catalog_pb.guidReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.guidRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/GetGuid',
        request,
        metadata || {},
        this.methodDescriptorGetGuid,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/GetGuid',
    request,
    metadata || {},
    this.methodDescriptorGetGuid);
  }

  methodDescriptorGetCart = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/GetCart',
    grpcWeb.MethodType.UNARY,
    catalog_pb.CartReq,
    catalog_pb.CartRes,
    (request: catalog_pb.CartReq) => {
      return request.serializeBinary();
    },
    catalog_pb.CartRes.deserializeBinary
  );

  getCart(
    request: catalog_pb.CartReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.CartRes>;

  getCart(
    request: catalog_pb.CartReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.CartRes) => void): grpcWeb.ClientReadableStream<catalog_pb.CartRes>;

  getCart(
    request: catalog_pb.CartReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.CartRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/GetCart',
        request,
        metadata || {},
        this.methodDescriptorGetCart,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/GetCart',
    request,
    metadata || {},
    this.methodDescriptorGetCart);
  }

  methodDescriptorCartAdd = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/CartAdd',
    grpcWeb.MethodType.UNARY,
    catalog_pb.CartAddReq,
    catalog_pb.CartRes,
    (request: catalog_pb.CartAddReq) => {
      return request.serializeBinary();
    },
    catalog_pb.CartRes.deserializeBinary
  );

  cartAdd(
    request: catalog_pb.CartAddReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.CartRes>;

  cartAdd(
    request: catalog_pb.CartAddReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.CartRes) => void): grpcWeb.ClientReadableStream<catalog_pb.CartRes>;

  cartAdd(
    request: catalog_pb.CartAddReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.CartRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/CartAdd',
        request,
        metadata || {},
        this.methodDescriptorCartAdd,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/CartAdd',
    request,
    metadata || {},
    this.methodDescriptorCartAdd);
  }

  methodDescriptorCartUpdate = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/CartUpdate',
    grpcWeb.MethodType.UNARY,
    catalog_pb.CartAddReq,
    catalog_pb.CartRes,
    (request: catalog_pb.CartAddReq) => {
      return request.serializeBinary();
    },
    catalog_pb.CartRes.deserializeBinary
  );

  cartUpdate(
    request: catalog_pb.CartAddReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.CartRes>;

  cartUpdate(
    request: catalog_pb.CartAddReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.CartRes) => void): grpcWeb.ClientReadableStream<catalog_pb.CartRes>;

  cartUpdate(
    request: catalog_pb.CartAddReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.CartRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/CartUpdate',
        request,
        metadata || {},
        this.methodDescriptorCartUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/CartUpdate',
    request,
    metadata || {},
    this.methodDescriptorCartUpdate);
  }

  methodDescriptorCartRemove = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/CartRemove',
    grpcWeb.MethodType.UNARY,
    catalog_pb.CartRemoveReq,
    catalog_pb.CartRes,
    (request: catalog_pb.CartRemoveReq) => {
      return request.serializeBinary();
    },
    catalog_pb.CartRes.deserializeBinary
  );

  cartRemove(
    request: catalog_pb.CartRemoveReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.CartRes>;

  cartRemove(
    request: catalog_pb.CartRemoveReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.CartRes) => void): grpcWeb.ClientReadableStream<catalog_pb.CartRes>;

  cartRemove(
    request: catalog_pb.CartRemoveReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.CartRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/CartRemove',
        request,
        metadata || {},
        this.methodDescriptorCartRemove,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/CartRemove',
    request,
    metadata || {},
    this.methodDescriptorCartRemove);
  }

  methodDescriptorOrderAccept = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/OrderAccept',
    grpcWeb.MethodType.UNARY,
    catalog_pb.OrderAcceptReq,
    catalog_pb.OrderAcceptRes,
    (request: catalog_pb.OrderAcceptReq) => {
      return request.serializeBinary();
    },
    catalog_pb.OrderAcceptRes.deserializeBinary
  );

  orderAccept(
    request: catalog_pb.OrderAcceptReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.OrderAcceptRes>;

  orderAccept(
    request: catalog_pb.OrderAcceptReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.OrderAcceptRes) => void): grpcWeb.ClientReadableStream<catalog_pb.OrderAcceptRes>;

  orderAccept(
    request: catalog_pb.OrderAcceptReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.OrderAcceptRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/OrderAccept',
        request,
        metadata || {},
        this.methodDescriptorOrderAccept,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/OrderAccept',
    request,
    metadata || {},
    this.methodDescriptorOrderAccept);
  }

  methodDescriptorAutoRequest = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/AutoRequest',
    grpcWeb.MethodType.UNARY,
    catalog_pb.AutoReq,
    catalog_pb.AutoRes,
    (request: catalog_pb.AutoReq) => {
      return request.serializeBinary();
    },
    catalog_pb.AutoRes.deserializeBinary
  );

  autoRequest(
    request: catalog_pb.AutoReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.AutoRes>;

  autoRequest(
    request: catalog_pb.AutoReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.AutoRes) => void): grpcWeb.ClientReadableStream<catalog_pb.AutoRes>;

  autoRequest(
    request: catalog_pb.AutoReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.AutoRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/AutoRequest',
        request,
        metadata || {},
        this.methodDescriptorAutoRequest,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/AutoRequest',
    request,
    metadata || {},
    this.methodDescriptorAutoRequest);
  }

  methodDescriptorModelRequest = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/ModelRequest',
    grpcWeb.MethodType.UNARY,
    catalog_pb.ModelReq,
    catalog_pb.ModelRes,
    (request: catalog_pb.ModelReq) => {
      return request.serializeBinary();
    },
    catalog_pb.ModelRes.deserializeBinary
  );

  modelRequest(
    request: catalog_pb.ModelReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.ModelRes>;

  modelRequest(
    request: catalog_pb.ModelReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.ModelRes) => void): grpcWeb.ClientReadableStream<catalog_pb.ModelRes>;

  modelRequest(
    request: catalog_pb.ModelReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.ModelRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/ModelRequest',
        request,
        metadata || {},
        this.methodDescriptorModelRequest,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/ModelRequest',
    request,
    metadata || {},
    this.methodDescriptorModelRequest);
  }

  methodDescriptorModRequest = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/ModRequest',
    grpcWeb.MethodType.UNARY,
    catalog_pb.ModReq,
    catalog_pb.ModRes,
    (request: catalog_pb.ModReq) => {
      return request.serializeBinary();
    },
    catalog_pb.ModRes.deserializeBinary
  );

  modRequest(
    request: catalog_pb.ModReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.ModRes>;

  modRequest(
    request: catalog_pb.ModReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.ModRes) => void): grpcWeb.ClientReadableStream<catalog_pb.ModRes>;

  modRequest(
    request: catalog_pb.ModReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.ModRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/ModRequest',
        request,
        metadata || {},
        this.methodDescriptorModRequest,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/ModRequest',
    request,
    metadata || {},
    this.methodDescriptorModRequest);
  }

  methodDescriptorSizeRequest = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/SizeRequest',
    grpcWeb.MethodType.UNARY,
    catalog_pb.TireSizeReq,
    catalog_pb.TrieSizeRes,
    (request: catalog_pb.TireSizeReq) => {
      return request.serializeBinary();
    },
    catalog_pb.TrieSizeRes.deserializeBinary
  );

  sizeRequest(
    request: catalog_pb.TireSizeReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.TrieSizeRes>;

  sizeRequest(
    request: catalog_pb.TireSizeReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.TrieSizeRes) => void): grpcWeb.ClientReadableStream<catalog_pb.TrieSizeRes>;

  sizeRequest(
    request: catalog_pb.TireSizeReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.TrieSizeRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/SizeRequest',
        request,
        metadata || {},
        this.methodDescriptorSizeRequest,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/SizeRequest',
    request,
    metadata || {},
    this.methodDescriptorSizeRequest);
  }

  methodDescriptorYearRequest = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/YearRequest',
    grpcWeb.MethodType.UNARY,
    catalog_pb.YearsReq,
    catalog_pb.YearsRes,
    (request: catalog_pb.YearsReq) => {
      return request.serializeBinary();
    },
    catalog_pb.YearsRes.deserializeBinary
  );

  yearRequest(
    request: catalog_pb.YearsReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.YearsRes>;

  yearRequest(
    request: catalog_pb.YearsReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.YearsRes) => void): grpcWeb.ClientReadableStream<catalog_pb.YearsRes>;

  yearRequest(
    request: catalog_pb.YearsReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.YearsRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/YearRequest',
        request,
        metadata || {},
        this.methodDescriptorYearRequest,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/YearRequest',
    request,
    metadata || {},
    this.methodDescriptorYearRequest);
  }

  methodDescriptorGetAnalogList = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/GetAnalogList',
    grpcWeb.MethodType.UNARY,
    catalog_pb.ItemsByAnalogReq,
    catalog_pb.CatalogItemList,
    (request: catalog_pb.ItemsByAnalogReq) => {
      return request.serializeBinary();
    },
    catalog_pb.CatalogItemList.deserializeBinary
  );

  getAnalogList(
    request: catalog_pb.ItemsByAnalogReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.CatalogItemList>;

  getAnalogList(
    request: catalog_pb.ItemsByAnalogReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.CatalogItemList) => void): grpcWeb.ClientReadableStream<catalog_pb.CatalogItemList>;

  getAnalogList(
    request: catalog_pb.ItemsByAnalogReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.CatalogItemList) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/GetAnalogList',
        request,
        metadata || {},
        this.methodDescriptorGetAnalogList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/GetAnalogList',
    request,
    metadata || {},
    this.methodDescriptorGetAnalogList);
  }

  methodDescriptorGetModelList = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/GetModelList',
    grpcWeb.MethodType.UNARY,
    catalog_pb.ModelListReq,
    catalog_pb.ModelRes,
    (request: catalog_pb.ModelListReq) => {
      return request.serializeBinary();
    },
    catalog_pb.ModelRes.deserializeBinary
  );

  getModelList(
    request: catalog_pb.ModelListReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.ModelRes>;

  getModelList(
    request: catalog_pb.ModelListReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.ModelRes) => void): grpcWeb.ClientReadableStream<catalog_pb.ModelRes>;

  getModelList(
    request: catalog_pb.ModelListReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.ModelRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/GetModelList',
        request,
        metadata || {},
        this.methodDescriptorGetModelList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/GetModelList',
    request,
    metadata || {},
    this.methodDescriptorGetModelList);
  }

  methodDescriptorGetSearchList = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/GetSearchList',
    grpcWeb.MethodType.UNARY,
    catalog_pb.SearchReq,
    catalog_pb.SearchListRes,
    (request: catalog_pb.SearchReq) => {
      return request.serializeBinary();
    },
    catalog_pb.SearchListRes.deserializeBinary
  );

  getSearchList(
    request: catalog_pb.SearchReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.SearchListRes>;

  getSearchList(
    request: catalog_pb.SearchReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.SearchListRes) => void): grpcWeb.ClientReadableStream<catalog_pb.SearchListRes>;

  getSearchList(
    request: catalog_pb.SearchReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.SearchListRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/GetSearchList',
        request,
        metadata || {},
        this.methodDescriptorGetSearchList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/GetSearchList',
    request,
    metadata || {},
    this.methodDescriptorGetSearchList);
  }

  methodDescriptorSendMsg = new grpcWeb.MethodDescriptor(
    '/catalog.CatalogItemReq/SendMsg',
    grpcWeb.MethodType.UNARY,
    catalog_pb.MsqReq,
    catalog_pb.MsqRes,
    (request: catalog_pb.MsqReq) => {
      return request.serializeBinary();
    },
    catalog_pb.MsqRes.deserializeBinary
  );

  sendMsg(
    request: catalog_pb.MsqReq,
    metadata?: grpcWeb.Metadata | null): Promise<catalog_pb.MsqRes>;

  sendMsg(
    request: catalog_pb.MsqReq,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: catalog_pb.MsqRes) => void): grpcWeb.ClientReadableStream<catalog_pb.MsqRes>;

  sendMsg(
    request: catalog_pb.MsqReq,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: catalog_pb.MsqRes) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/catalog.CatalogItemReq/SendMsg',
        request,
        metadata || {},
        this.methodDescriptorSendMsg,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/catalog.CatalogItemReq/SendMsg',
    request,
    metadata || {},
    this.methodDescriptorSendMsg);
  }

}

